import React, { useState, useEffect } from "react";
import classes from "../../controls.module.scss";
import eventClasses from "./bulkupdate.module.scss"
import { Box, Grid, Button, IconButton, Typography } from '@mui/material';
import { Icon, Dialog, useToggle, Radio,DatePicker } from '@genesis/ui-kit';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, RadioGroup } from '@mui/material';
import { Checkbox } from '@genesis/ui-kit';
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { constants } from "../../../../Shared/Url/Constants";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import bloomiesReceiptIcon from "../../../../Resources/bloomiesrcpt.png"
import add from "../../../../Resources/add.png";
import duplicate from "../../../../Resources/duplicate.png";
import deleteimg from "../../../../Resources/delete.png";
import add_disable from "../../../../Resources/add_disable.png";
import duplicate_disable from "../../../../Resources/duplicate_disable.png";
import delete_disable from "../../../../Resources/delete_disable.png";
import warning_delete from "../../../../Resources/warning_delete.png";


import EventHours from "./EventHours";
import EventShifts from "./EventShifts";
import ScheduledAreas from "./ScheduledAreas";
import WorkSchedule from "./WorkSchedule";
import Edit from "./Edit"
import { useLocation, useNavigate } from "react-router-dom";
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CalIcon } from "../../../../Resources/availabilityicon/IconUtils";
import moment from 'moment';
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import NotificationView from "../../../../Shared/Notification/NotificationView";
import { toUpperCaseString } from "../../../../Shared/Utill/Utills";
import EventLocationsDialog from "../EventLocationsList/EventLocationsDialog";
import BulkUpdateDialog from "./BulkUpdateDialog";
/*
* dneed to have use effect to handle rerendering of page on delete/add of event hours.
* need to have method that will run firstrow method and a loop of add rows method depending on 
* # of elements to map through  based on API repsonse/props for event hours.
*/
const SEBulkUpdateEventsPage = () => {
    
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const dialog = useToggle();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [rowCount, updateRowCount] = React.useState(1)
    const [startTime, setStartTime] = React.useState({})
    const [endTime, setEndTime] = React.useState("")
    const [eventHoursList, setEventHoursList] = React.useState([])
    const [readOnlyView, setReadyOnly] = React.useState(false);
    const [haveRemoved, setHaveRemoved] = React.useState(true);
    const [haveAdded, setHaveAdded] = React.useState(true);
    const location = useLocation();
    const [scheduleArea, setscheduleArea] = React.useState(" ")
    const [scheduleDepartment, setScheduleDepartment] = React.useState("No Change")
    const [workSchedule, setWorkSchedule] = React.useState(" ")
    const [workScheduleDepartment, setWorkScheduleDepartment] = React.useState("No Change")
    const [allowSplitShift, setAllowSplitShift] = React.useState(false)
    const [forceMinSelectionHours, setForceMinSelectionHours] = React.useState("No Change")
    const [activateEvent, setActivateEvent] = React.useState(false)
    const token = Cookie.get('X_TKN');
    const [allowPartialShiftSelection, setAllowPartialShiftSelection] = React.useState("");
    const { message, severity, open } = isAlertOpen || {};
    const [divSelectedValue, setDivSelectedValue] = useState(null);

    const [startHours, setStartHours] = React.useState({})
    const [endHours, setEndHours] = React.useState({})

    // state for locations component
    const [locationsProps,setLocationsProps] = React.useState(location.state.data)
    const [showLocations,setShowLocations] = React.useState(false)

    // event details states
    const [eventStartDate, setEventStartDate] = React.useState("");
    const [eventEndDate, setEventEndDate] = React.useState("");
    const [displayStartDate, setDisplayStartDate] = React.useState("");
    const [displayEndDate, setDisplayEndDate] = React.useState("");
    const [division, setDivision] = React.useState(location.state.data.division);
    
    const [eventId, setEventId] = React.useState(location.state.data.eventid);
    const [eventName, setEventName] = React.useState(location.state.data.eventname);
    const [eventBaseData, setEventBaseData] = React.useState(location.state.data)
    const [eventDetailApiData, setEventDetailApiData] = React.useState(null);
    const [eventStatus,setEventStatus] = React.useState("No Change");
    const [colleagueUnavailability,setColleagueUnAvailibility] = React.useState("No Change");
    const [divList, setDivList] = useState([]);

    //shifts state
    const [shiftsDropDownIntervals, setShiftsDropDownIntervals] = React.useState("");
    const [shiftsMinimumSelectionHours, setshiftsMinimumSelectionHours] = React.useState("");
    const [splitShift,setSplitShift] = React.useState("No Change");
    const [forceMinShiftHrs,setForceMinShiftHrs] = React.useState("No Change");

    // other opertaion enable/disable
    const [ongoingActionCompleted, setOngoingActionCompleted] = React.useState(true);

    // get flag from previous page.
    const [flag, setFlag] = React.useState(location.state.flag);

    //cancel editing
    const [cancelFlag, setCancelFlag] = React.useState(false);

   

    const history = useNavigate();

  
    const [openDialog, setOpenDialog] = useState(false);
    const [openBulkUpdateDialog, setOpenBulkUpdateDialog] = useState(false);

    console.log("event base data", eventBaseData)
    const checkBoxOptionsOne = ["Inactive","Active","No Change"]
    const checkBoxOptionsTwo = ["No","Yes","No Change"]
    const checkBoxOptionsThree = ["Include","Exclude","No Change"]
    const checkBoxOptionsFour = ["On","Off","No Change"]

    
    /*
    *Setup method for mapping through json event hours depending on eventhours add/delete to map
    *Setup boolean state for showing add/delete based on map element
    */

    useEffect(() => {
        let divList = ['Include','Exclude']
        setDivList(divList)

        
        if (eventBaseData.locId !== null && (flag === 'E' || flag === 'C')) {
            if(flag ==='C') {
                setReadyOnly(false);
                setOngoingActionCompleted(false);
                setAlertOpen({
                    open: true,
                    severity: "success",
                    message: "Please edit and save to duplicate into a new event location",
                })
            }
           
        } else {
            // set flag to A
            setFlag("A");

            // set the state when Flag is A
            setDivision(eventBaseData.divNbr + "-" + eventBaseData.divName);
            
            setEventId(eventBaseData.eventId);
            setEventName(eventBaseData.eventName);

            // set editable to false
            setReadyOnly(false);
            setOngoingActionCompleted(false);

        }

    }, [showLocations]);



    const makeEditable = () => {
        setOngoingActionCompleted(false);
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadyOnly(false)
        }
        setCancelFlag(!cancelFlag)
    }
    const makeReadOnly = () => {
        //on click of save
        setOngoingActionCompleted(true);
        if (readOnlyView == false) {
            setReadyOnly(true)
        }
    }
    const listLocations = () => {
        console.log("will it work?")
        setShowLocations(true);
    }
    const onCloseDialog = () => {
        console.log("will it work?")
        setShowLocations(false);
        setOpenBulkUpdateDialog(false)
      }



    const addEvent = () => {
        setFlag("A");
        // set editable to false
        setReadyOnly(false);
        setOngoingActionCompleted(false);
        setEventDetailApiData(null)

        // reset values to default   

        // location and event dates reset
        setEventStartDate(null);
        setEventEndDate(null);
        setDisplayStartDate(null);
        setDisplayEndDate(null);
        

        // activated event checkbox reset
        setActivateEvent(false);

        // shifts reset
        setShiftsDropDownIntervals("");
        setshiftsMinimumSelectionHours("");
        setAllowSplitShift(false);
        setForceMinSelectionHours(false);

        // department reset

        setscheduleArea("")
        //setscheduleAreaRadio("")
        setWorkSchedule("")
        //setWorkScheduleRadio("")

    }

    const duplicateEvent = () => {
        setFlag("C");
        setReadyOnly(false);
        setOngoingActionCompleted(false);
        
        setAlertOpen({
            open: true,
            severity: "success",
            message: "Please edit and save to duplicate into a new event location",
        })
    }
    const closeSaveDialog = () => {
        setOpenDialog(false);
      }

    

    const Edit = () => {
        return (
            <div>
                <div className={eventClasses.eventpagemargin}>
                    <Grid container spacing={3} >
                        <Grid item xs={2}>
                            <div className={eventClasses.scheduledAreas}>  </div>
                        </Grid>
                        <Grid item xs={2}>

                        </Grid>
                        <Grid item xs={2} >

                        </Grid>
                        <Grid item xs={3} >
                            {!readOnlyView && (flag === "E" || flag === "C") && <Button sx={{ minWidth: "100%" }} color="secondary" onClick={cancelEditing} >Cancel</Button>}
                            {!readOnlyView && flag === "A" && <Button sx={{ minWidth: "100%" }} color="secondary" onClick={() => history("/controls/specialeventscontrols/searchevent")} >Cancel</Button>}
                        </Grid>
                        <Grid item xs={3} >
                            {readOnlyView ?
                                <Button sx={{ minWidth: "100%" }} onClick={makeEditable} >Edit</Button>
                                : <Button sx={{ minWidth: "100%" }} onClick={saveData} >Save</Button>}

                        </Grid>
                        <Grid item xs={2} >
                        </Grid>
                    </Grid>

                </div>
            </div>
        )
    }

    const changeWorkScheduleDepartment = (e) => {
        setWorkScheduleDepartment(e.target.value)
    }

    const changeWorkSchedule = (e) => {
        setWorkSchedule(e.target.value)
    }

    const changeScheduleDepartment = (e) => {
        setScheduleDepartment(e.target.value)
    }

    const changeScheduleArea = (e) => {
        setscheduleArea(e.target.value)
    }

    const changeAllowSplitShift = (e) => {
        setAllowSplitShift(e.target.checked)
    }


    const changeActivateEvent = (e) => {
        setActivateEvent(e.target.checked)
    }

    const changeDropDownIntervals = (e) => {
        setShiftsDropDownIntervals(e.target.value)
    }

    const changeShiftsMinimumSelectionHours = (e) => {
        setshiftsMinimumSelectionHours(e.target.value)
    }

    const changeSplitShift = (e) => {
        setSplitShift(e.target.value)
    }

    const changeMinShiftHours = (e) => {
        setForceMinShiftHrs(e.target.value)
    }
    
    const changeEventStatus = (e) => {
        console.log("status set",e.target.value)
        setEventStatus(e.target.value)
    }
    
    const changeColleagueUnavailibility = (e) => {
        setColleagueUnAvailibility(e.target.value)
    }

    const cancelEditing = () => {
        setOngoingActionCompleted(true);
        // call api to reset values
        makeReadOnly();
       
        setCancelFlag(!cancelFlag)
    }

    const onBulkUpdateCallback = (responseType,message) => {
        onCloseDialog();
        //handle success / failue
        setAlertOpen({
          open: true,
          severity: responseType,
          message : message,
        });
        // refresh data
        
      }


   

    const setUpEventDetailsStatesValues = (resp, flag1 = null) => {
        // setup initial values from getData API for event details sections
        setEventStartDate(resp.eventDetailsEventStartDate);
        setEventEndDate(resp.eventDetailsEventEndDate);
        setDisplayStartDate(resp.eventDetailsDisplayStartDate);
        setDisplayEndDate(resp.eventDetailsDisplayEndDate);
        setDivision(resp.divNbr + "-" + resp.divName);
        //setEventLocation(flag === 'C' & flag1 === null  ? "" : resp.locNbr);
        setEventId(resp.eventId);
        setEventName(resp.eventName);
        //setActivateEvent(toUpperCaseString(resp.eventDetailsActive) == 'Y' ? true : false);
        //setEventLocationId(resp.locId);
    }

    
    const updateEventHours = (start, end) => {
        console.log("start in main page", start);
        console.log("end in main page", end);
        setStartHours(start);
        setEndHours(end);
    }

    const updateAllowPartial = (val) => {
        console.log("testing",val)
        setAllowPartialShiftSelection(val)
}

    const handleAlertNotifClose = () => {
        setAlertOpen({});
    };

    const getEventApi = async (div = null, edit = null) => {
        
        let data = {
            divNbr:  div !== null ? div : eventBaseData.divnbr,
            eventName: edit !== null ? edit : eventBaseData.eventname
        }
        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_GET_BY_DIV_NBR_EVENT_NAME}`,
            data,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then((response) => {
                console.log("response is", response.data)
                //setUseBaseData(false);
                //setEventApiData(response.data);
                setEventName(response.data[0].eventName)
                setEventId(response.data[0].eventId);
                //console.log(eventApiData[0])
                if (ongoingActionCompleted) {
                  //  setUseApiData(true);
                    setDivision(response.data[0].divNbr);
                    setEventId(response.data[0].eventId);
                    setEventName(response.data[0].eventName)
                }    
            })
            .catch((error) => {
                if(error.message === 'Network Error') {
                    history("/somethingwentwrong", {state:`Please logout and try again `})
                  }

            })
    }


    

    const saveData = () => {
        setOpenBulkUpdateDialog(true)
        //alert("data saving")
        /*let len = Object.keys(startHours).length;
        let eventHours = [];
        for (let i = 1; i <= len; i++) {
            let tmp = {};
            tmp.seqNbr = i;
            tmp.ctlName = "ddeventdayhrs";
            tmp.value1 = startHours[i];
            tmp.value2 = endHours[`end-${i}`]
            eventHours.push(tmp)
        }
        console.log(eventHours);
        // check if any eventHours is null and throw error
        const isEventHoursNull = Object.values(eventHours).some(x => (x.value1 === null || x.value2 === null));
        // check if locnbr has string
        //let locNbrvalid = isNaN(eventLocation) === true ? false : true;
        if (isEventHoursNull) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Event Hours cannot be null.",
            })

        } else {

            let momentEventStartDate = moment(eventStartDate).format('MM/DD/YYYY');
            let momentEventEndDate = moment(eventEndDate).format('MM/DD/YYYY');
            let momentDisplayStartDate = moment(displayStartDate).format('MM/DD/YYYY');
            let momentDisplayEndDate = moment(displayEndDate).format('MM/DD/YYYY');

            let data = {
                eventId: eventId !== null ? eventId : "",
                eventDetailsEventStartDate: momentEventStartDate !== "Invalid date" ? momentEventStartDate : "",
                eventDetailsEventEndDate: momentEventEndDate !== "Invalid date" ? momentEventEndDate : "",
                eventDetailsDisplayStartDate: momentDisplayStartDate !== "Invalid date" ? momentDisplayStartDate : "",
                eventDetailsDisplayEndDate: momentDisplayEndDate !== "Invalid date" ? momentDisplayEndDate : "",
                eventDetailsActive: activateEvent === true ? 'y' : 'n',
                shiftsDropDownIntervals: shiftsDropDownIntervals,
                shiftsAllowSplitShifts: splitShift === true ? 'y' : 'n',
                shiftsMinimumSelectionHours: shiftsMinimumSelectionHours,
                shiftsForceMinimumSelectionHours: forceMinShiftHrs === true ? 'y' : 'n',
                eventHours: eventHours,
                eventHoursAllowPartialShiftSelection: allowPartialShiftSelection,
                scheduleAreasDptValues: scheduleArea,
                scheduleAreasDptIncluded: scheduleDepartment === "Include" ? 'y' : 'n',
                workScheduleWsIncluded: workScheduleDepartment === "Include" ? 'y' : 'n',
                workScheduleWsValues: workSchedule,
                
                
                lastUpdatedBy: "BulkUpdate"
            }
            console.log(data)


            axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_CONTROL_BULK_UPDATE}`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    }
                }).then((res) => {
                    // call api to fetch data
                    if (flag === "E" || flag === "C") {
                        makeReadOnly();
                        setAlertOpen({
                            open: true,
                            severity: "success",
                            message: "All locations in this event were updated successfully",
                        })
                    }

                    

                    


                }).catch((err) => {
                    //alert("error")
                    setAlertOpen({
                        open: true,
                        severity: "error",
                        message: err.response.data.message,
                    })
                });
        } // evenhours not null */
    }
   
    let locid = eventBaseData.locId
    return (
        <div className={classes.eventpagemargin}>


            <div style={{ width: "100%" }}>
                <div className={eventClasses.eventpagetitle} style={{ textAlign: "left", width: "40%" }} >{"Bulk Update"}</div>
                
            </div>
            {
                <div style={{width:"82.75%"}}>
                <NotificationView 
                    message={"Only fill in fields that need to be bulk-updated; blank fields will be unaffected. Bulk update changes will impact all locations in the event."} 
                    severity="info"
                     />
                </div>
            }
            <div className={eventClasses.eventiconmargin}>



                <div className={classes.pagesubtitle}> </div>
                { /*  Event details code goes here */}

                <div>


                    <div className={eventClasses.eventpagemargin}>


                        <Grid container spacing={4} >

                            <Grid item xs={2}>
                                <div className={eventClasses.eventDetails}> Event Details </div>
                            </Grid>

                            <Grid item xs={2} >
                                <TextField inputProps={{ readOnly: true }} sx={{ minWidth: "100%" }} label="Division" value={division} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField inputProps={{ readOnly: true }} sx={{ minWidth: "100%" }} label="Event ID" value={eventId} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField inputProps={{ readOnly: true }} sx={{ minWidth: "100%" }} label="Event Name" value={eventName} />
                            </Grid>
                            <Grid item xs={2}>
                            
                            <a onClick={() => listLocations()} style={{cursor: 'pointer', textDecoration: "underline" }}>Location(s)</a>
                               {showLocations &&  <EventLocationsDialog onCloseDialog={onCloseDialog} data = {locationsProps} />}
                            
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Event Start Date(Opt)"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={eventStartDate||null}
                                        onChange={(newValue) => {
                                            setEventStartDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Event End Date(Opt)"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={eventEndDate||null}
                                        onChange={(newValue) => {
                                            setEventEndDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Display Start Date(Opt)"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={displayStartDate||null}
                                        onChange={(newValue) => {
                                            setDisplayStartDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Display End Date(Opt)"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={displayEndDate||null}
                                        onChange={(newValue) => {
                                            setDisplayEndDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2} >
                            <FormControl sx={{ minWidth:"100%" }}>
                            <InputLabel id="demo-select-basic-label">Event Status</InputLabel>
                            <Select
                                labelId="demo-select-basic-label"
                                id="demo-select-basic"
                                label="Event Status"
                                inputProps={{ readOnly: readOnlyView }}
                                onChange = {e => changeEventStatus(e)}
                                value={eventStatus || ''}
                            >
                                {checkBoxOptionsOne && checkBoxOptionsOne.map((e) =>
                                <MenuItem key={e} value={e}>{e}</MenuItem>
                                )}
                            </Select>
                            </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                            <FormControl sx={{ minWidth:"100%" }}>
                            <InputLabel id="demo-select-basic-label">Colleague Unavailability</InputLabel>
                            <Select
                                labelId="demo-select-basic-label"
                                id="demo-select-basic"
                                label="Event Status"
                                inputProps={{ readOnly: readOnlyView }}
                                onChange = {e => changeColleagueUnavailibility(e)}
                                value={colleagueUnavailability || ''}
                            >
                                {checkBoxOptionsTwo && checkBoxOptionsTwo.map((e) =>
                                <MenuItem key={e} value={e}>{e}</MenuItem>
                                )}
                            </Select>
                            </FormControl>
                           
                            </Grid>
                            <Grid item xs={8} >
                            </Grid>

                        </Grid>
                    </div>

                </div>



                { /*  Event shift code goes here */}

                <div>

                    <div className={eventClasses.eventpagemargin}>


                        <Grid container spacing={4} columns={6}>

                            <Grid item xs={1}>
                                <div className={eventClasses.shift}>Shifts</div>
                            </Grid>

                            <Grid item xs={1}>
                                <TextField inputProps={{ readOnly: readOnlyView }} sx={{ minWidth: "100%" }} label="Drop Down Intervals(Opt)" value={shiftsDropDownIntervals} onChange={changeDropDownIntervals} />
                            </Grid>
                            <Grid item xs={1} >
                                <TextField inputProps={{ readOnly: readOnlyView }} sx={{ minWidth: "100%" }} label="Enter Minimum Selection Hrs(Opt)" value={shiftsMinimumSelectionHours} onChange={changeShiftsMinimumSelectionHours} />
                            </Grid>
                            <Grid item xs={1} >
                            <FormControl sx={{ minWidth:"100%" }}>
                            <InputLabel id="demo-select-basic-label">Split Shifts</InputLabel>
                            <Select
                                labelId="demo-select-basic-label"
                                id="demo-select-basic"
                                label="Event Status"
                                inputProps={{ readOnly: readOnlyView }}
                                onChange = {e => changeSplitShift(e)}
                                value={splitShift || ''}
                            >
                                {checkBoxOptionsFour && checkBoxOptionsFour.map((e) =>
                                <MenuItem key={e} value={e}>{e}</MenuItem>
                                )}
                            </Select>
                            </FormControl>
                            
                            </Grid>
                            <Grid item xs={1} >
                            <FormControl sx={{ minWidth:"100%" }}>
                            <InputLabel id="demo-select-basic-label">Force Min Shift Hrs</InputLabel>
                            <Select
                                labelId="demo-select-basic-label"
                                id="demo-select-basic"
                                label="Force Min Shift Hrs"
                                inputProps={{ readOnly: readOnlyView }}
                                onChange = {e => changeMinShiftHours(e)}
                                value={forceMinShiftHrs || ''}
                            >
                                {checkBoxOptionsTwo && checkBoxOptionsTwo.map((e) =>
                                <MenuItem key={e} value={e}>{e}</MenuItem>
                                )}
                            </Select>
                            </FormControl>
                            
                            </Grid>
                            <Grid item xs={1} >
                            </Grid>
                            <Grid item xs={1} >
                            </Grid>
                            <Grid item xs={1} >
                                
                            </Grid>
                            <Grid item xs={2} >
                                
                            </Grid>
                            

                        </Grid>
                    </div>

                </div>


                {((eventDetailApiData === null || flag === "A") && (flag === "E" || flag === "A" || flag === "C")) &&
                    <EventHours flag={flag} cancelFlag={cancelFlag} readOnlyView={readOnlyView} updateEventHours={updateEventHours} updateAllowPartial={updateAllowPartial} eventHours={eventDetailApiData !== null ? eventDetailApiData.eventHours : []} eventHoursAllowPartialShiftSelection={eventDetailApiData !== null ? eventDetailApiData.eventHoursAllowPartialShiftSelection : null} />}



                { /*  schedule areas code goes here */}

                <div>
                    <div className={eventClasses.eventpagemargin}>
                        <Grid container spacing={3} >
                            <Grid item xs={2}>
                                <div className={eventClasses.scheduledAreas}> Scheduled Areas </div>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField inputProps={{ readOnly: readOnlyView }} multiline={true} onChange={changeScheduleArea} sx={{ minWidth: "100%" }} label="Department (Opt)" value={scheduleArea} defaultValue={scheduleArea} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} >
                            <Grid item xs={12}>
                            </Grid>
                            <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={2} >
                            <FormControl sx={{ minWidth:"100%" }}>
                            <InputLabel id="demo-select-basic-label">Department Action</InputLabel>
                            <Select
                                labelId="demo-select-basic-label"
                                id="demo-select-basic"
                                label="Department Action"
                                inputProps={{ readOnly: readOnlyView }}
                                onChange = {e => changeScheduleDepartment(e)}
                                value={scheduleDepartment || ''}
                            >
                                {checkBoxOptionsThree && checkBoxOptionsThree.map((e) =>
                                <MenuItem key={e} value={e}>{e}</MenuItem>
                                )}
                            </Select>
                            </FormControl>
                            
                            </Grid>
                            <Grid  item xs={12} >
                            </Grid>

                        </Grid>


                    </div>
                </div>


                { /* work schedule code goes here */}

                <div>
                    <div className={eventClasses.eventpagemargin}>
                        <Grid container spacing={3} >
                            <Grid item xs={2}>
                                <div className={eventClasses.scheduledAreas}> Work Schedule </div>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField inputProps={{ readOnly: readOnlyView }} multiline={true} onChange={changeWorkSchedule} sx={{ minWidth: "100%" }} label="Work Schedule (Opt)" value={workSchedule} defaultValue={workSchedule} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} >
                            <Grid item xs={12}>
                            </Grid>
                            <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={2} >
                            <FormControl sx={{ minWidth:"100%" }}>
                            <InputLabel id="demo-select-basic-label">Work Schedule Action</InputLabel>
                            <Select
                                labelId="demo-select-basic-label"
                                id="demo-select-basic"
                                label="Work Schedule Action"
                                inputProps={{ readOnly: readOnlyView }}
                                onChange = {e => changeWorkScheduleDepartment(e)}
                                value={workScheduleDepartment || ''}
                            >
                                {checkBoxOptionsThree && checkBoxOptionsThree.map((e) =>
                                <MenuItem key={e} value={e}>{e}</MenuItem>
                                )}
                            </Select>
                            </FormControl>
                           
                            </Grid>
                            <Grid  item xs={12} >
                            </Grid>

                        </Grid>


                    </div>

                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>
                    {<Edit readOnlyView={readOnlyView} />}
                    {openBulkUpdateDialog && 
                    <BulkUpdateDialog 
                    locationInfo={locationsProps}
                    onCloseDialog={onCloseDialog} 
                    onBulkUpdateCallback={onBulkUpdateCallback} 
                    eventId={eventId}
                    startHours={startHours}
                    endHours={endHours}
                    eventStartDate={eventStartDate}
                    eventEndDate={eventEndDate}
                    displayStartDate={displayStartDate}
                    displayEndDate={displayEndDate}
                    activateEvent={eventStatus}
                    shiftsDropDownIntervals={shiftsDropDownIntervals}
                    splitShift={splitShift}
                    shiftsMinimumSelectionHours={shiftsMinimumSelectionHours}
                    forceMinShiftHrs={forceMinShiftHrs}
                    flag={flag}
                    allowPartialShiftSelection={allowPartialShiftSelection}
                    scheduleArea={scheduleArea}
                    scheduleDepartment={scheduleDepartment}
                    workScheduleDepartment={workScheduleDepartment}
                    workSchedule={workSchedule}
                    makeReadOnly={ makeReadOnly}
                    setAlert={setAlertOpen}
                    colleagueUnavailability={colleagueUnavailability} 
                    />}
                </div>
            </div>
        </div>

    );
}

export default SEBulkUpdateEventsPage;